module.exports = __webpack_public_path__ + "img/logo.44d565b.png";